const Asterisk = () => {
  return <span className="text-red-500 ml-[2px]">*</span>;
};

export default Asterisk;
